import styled from 'styled-components';

export const StyledStatusIndicator = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: inline-block;
  cursor: help;
  vertical-align: middle;
`;

export const StyledTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  white-space: pre-wrap;
`;

export const StyledActionPath = styled.div`
  margin-top: 2px;
  &:before {
    content: '➜';
    margin-right: 4px;
  }
`;
